// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1_Pqs","cls2":"Unibrow-cls2__bc Unibrow-cls1_Pqs"};